import React from 'react';
import { roles } from '../../mock/content';
import { Cog, LineChart, Handshake, UsersRound } from 'lucide-react';
import Reveal from './Reveal';

const iconMap = { Cog, LineChart, Handshake, UsersRound };

const Roles = () => {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      {/* Background video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src="https://videos.pexels.com/video-files/3252148/3252148-uhd_2560_1440_25fps.mp4"
        poster="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      />
      {/* Light overlay for readability — kept subtle so the video shows through */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'linear-gradient(180deg, rgba(241,245,251,0.72) 0%, rgba(241,245,251,0.78) 100%)',
        }}
      />
      {/* Extra soft blur so cards read cleanly over motion */}
      <div className="absolute inset-0 backdrop-blur-[2px] pointer-events-none" />
      <div className="relative max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-brand-blue text-[12px] font-bold tracking-[0.16em] uppercase mb-4">
            Built for modern publisher teams
          </p>
          <h2 className="text-navy font-black tracking-[-0.01em] leading-[1.12] text-[32px] sm:text-[40px] md:text-[46px]">
            Every role gets what they need to move
          </h2>
          <p className="mt-6 text-body-muted text-[16px] leading-[1.7]">
            A new revenue line isn't one team's job. 5DBS gives every role the offer, delivery and reporting they need to make lead generation work — without leaving their comfort zone.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {roles.map((r, i) => {
            const Icon = iconMap[r.icon] || Cog;
            return (
              <Reveal
                key={r.title}
                delay={i * 100}
                className="bg-white rounded-2xl shadow-mk p-7 hover:shadow-mk-lg hover:-translate-y-1 transition-all duration-300"
              >
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-brand-blue to-brand-blue-light text-white shadow-mk-blue mb-5">
                  <Icon size={22} strokeWidth={2.2} />
                </div>
                <h3 className="text-navy text-[18px] font-bold leading-snug">{r.title}</h3>
                <p className="mt-3 text-body-muted text-[14px] leading-[1.7]">{r.body}</p>
                <a
                  href="#call"
                  className="mt-5 inline-flex items-center gap-1.5 text-brand-blue text-[12px] font-bold uppercase tracking-[0.08em] hover:gap-2.5 transition-all duration-300"
                >
                  Learn more →
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Roles;
